import { createReducer, on, Action } from '@ngrx/store';
import { EntityState, createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import * as PersonContactActions from '../_actions/personContact';
import { PersonContact } from '../_models';

export interface PersonContactState extends EntityState<PersonContact> {
  loading: boolean;
  error: any;
}

export const adapter: EntityAdapter<PersonContact> = createEntityAdapter<PersonContact>();

const initialState: PersonContactState = adapter.getInitialState({
  loading: false,
  error: null,
});

const personContactReducer = createReducer(
  initialState,

  on(PersonContactActions.loadPersonContacts, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),

  on(PersonContactActions.loadPersonContactsSuccess, (state, { personContacts }) =>
    adapter.setAll(personContacts, { ...state, loading: false })
  ),

  on(PersonContactActions.loadPersonContactsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  on(PersonContactActions.addPersonContactSuccess, (state, { personContact }) =>
    adapter.addOne(personContact, state)
  ),

  on(PersonContactActions.updatePersonContactSuccess, (state, { personContact }) =>
    adapter.upsertOne(personContact, state)
  ),

  on(PersonContactActions.deletePersonContactSuccess, (state, { id }) =>
    adapter.removeOne(id, state)
  ),

  on(
    PersonContactActions.addPersonContactFailure,
    PersonContactActions.updatePersonContactFailure,
    PersonContactActions.deletePersonContactFailure,
    (state, { error }) => ({
      ...state,
      error,
    })
  )
);

export function reducer(state: PersonContactState | undefined, action: Action) {
  return personContactReducer(state, action);
}

export const { selectAll, selectEntities, selectTotal } = adapter.getSelectors();
